
import { ComponentPropsWithoutRef, ReactNode, useState } from 'react';
import ArrowIcon from '../../pages/calendar/components/icons/ArrowIcon';
import classNames from 'classnames';
import { asMenuItem } from './MenuItem.utils';

interface MenuProps extends ComponentPropsWithoutRef<'div'> {
  children: ReactNode;
  icon?: ReactNode;
  title: string;
}

const Label = asMenuItem('div');

export default function SubMenu({ children, title, icon, className, ...rest }: MenuProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div
      className={classNames(
        'grid grid-rows-[max-content_0fr] overflow-clip transition-all',
        {'bg-secondary-transparent-5 rounded-r-2xl grid-rows-[max-content_1fr]': menuOpen },
        className
      )}
      {...rest}
    >
      <Label id={title} className="row-start-1 col-start-1 cursor-pointer" onClick={() => setMenuOpen(!menuOpen)}>
        {icon ? <div className="size-5 flex items-center justify-center">{icon}</div> : null}
        {title}
        <div className="-mr-3 grow" />
        <ArrowIcon data-target="arrow" className={classNames(
          'rotate-90 transition-all',
          { 'rotate-[270deg]': menuOpen },
        )} />
      </Label>
      <div className={classNames(
        'min-h-min flex flex-col mr-4 ml-10',
        'opacity-0 transition-all',
        '*:py-3 *:pl-8 *:pr-6 *:text-sm *:rounded-full *:hover:before:m-0',
        { 'opacity-100': menuOpen },
      )}>
        {children}
      </div>
    </div>
  );
}
